var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAutoIgnition = function SvgAutoIgnition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.667,
    y: 40.667,
    width: 18.667,
    height: 18.667,
    rx: 9.333,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.667,
    y: 46,
    width: 2.667,
    height: 8,
    rx: 1.333,
    fill: "#332C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.667,
    y: 34,
    width: 2.667,
    height: 2.667,
    rx: 1.333,
    fill: "#332C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.667,
    y: 48.667,
    width: 2.667,
    height: 2.667,
    rx: 1.333,
    transform: "rotate(90 36.667 48.667)",
    fill: "#332C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.515,
    y: 39.629,
    width: 2.667,
    height: 2.667,
    rx: 1.333,
    transform: "rotate(135 41.515 39.63)",
    fill: "#332C4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.73 56.734l2.88-10.75-4.837-1.296-6.484 24.2 4.193 3.698 2.186-2.246-.77-3.038-.77-3.038 2.186-2.245 2.185-2.246-.77-3.039z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.752 47.05a5.842 5.842 0 005.801-1.676l8.713-9.422a5.842 5.842 0 00.61-7.15l-3.44-5.292a5.842 5.842 0 00-3.387-2.46l-6.014-1.612a5.842 5.842 0 00-4.163.437l-5.625 2.865a5.842 5.842 0 00-3.046 6.496l2.834 12.516a5.842 5.842 0 004.185 4.352l3.532.947zm4.03-22.103a4.381 4.381 0 10-2.268 8.464 4.381 4.381 0 002.268-8.465z",
    fill: "#DFDFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.553 45.374l-.611-.566.611.566zm8.713-9.422l.612.566-.612-.566zm.61-7.15l-.7.455.7-.454zm-3.44-5.292l-.699.454.7-.454zm-13.564-3.635l.378.743-.378-.743zm-5.625 2.865l.379.742-.379-.742zm-3.046 6.496l.813-.184-.813.184zm2.834 12.516l.813-.184-.813.184zm12.907 3.056a5.009 5.009 0 01-4.974 1.438l-.432 1.61a6.675 6.675 0 006.63-1.916l-1.224-1.132zm8.712-9.422l-8.712 9.422 1.223 1.132 8.713-9.422-1.224-1.132zm.522-6.13a5.009 5.009 0 01-.522 6.13l1.224 1.131a6.675 6.675 0 00.696-8.168l-1.398.908zm-3.439-5.292l3.44 5.293 1.397-.908-3.439-5.293-1.398.908zm-2.903-2.11a5.01 5.01 0 012.903 2.11l1.398-.908a6.676 6.676 0 00-3.87-2.811l-.431 1.61zm-6.015-1.61l6.015 1.61.431-1.61-6.014-1.61-.432 1.61zm-3.569.374a5.009 5.009 0 013.57-.375l.43-1.61a6.676 6.676 0 00-4.756.5l.756 1.485zm-5.624 2.864l5.624-2.864-.756-1.485-5.625 2.864.757 1.485zm-2.613 5.57a5.009 5.009 0 012.613-5.57l-.757-1.485a6.675 6.675 0 00-3.481 7.423l1.626-.368zm2.834 12.516l-2.833-12.516-1.626.368 2.834 12.516 1.625-.368zm3.59 3.731a5.009 5.009 0 01-3.59-3.731l-1.625.368a6.675 6.675 0 004.783 4.973l.431-1.61zm3.53.947l-3.53-.947-.432 1.61 3.531.947.432-1.61zm-.746-17.986a3.548 3.548 0 014.346-2.509l.431-1.61a5.215 5.215 0 00-6.387 3.688l1.61.431zm2.509 4.346a3.548 3.548 0 01-2.509-4.346l-1.61-.431a5.215 5.215 0 003.688 6.387l.431-1.61zm4.346-2.509a3.548 3.548 0 01-4.346 2.509l-.431 1.61a5.215 5.215 0 006.386-3.688l-1.61-.431zm-2.51-4.346a3.548 3.548 0 012.51 4.346l1.61.431a5.215 5.215 0 00-3.688-6.386l-.431 1.61z",
    fill: "#332C4A"
  })));
};

export default SvgAutoIgnition;